import { render, staticRenderFns } from "./CariDetayComponent.vue?vue&type=template&id=1f7a6db1"
import script from "./CariDetayComponent.vue?vue&type=script&lang=js"
export * from "./CariDetayComponent.vue?vue&type=script&lang=js"
import style0 from "./CariDetayComponent.vue?vue&type=style&index=0&id=1f7a6db1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports